module.exports = __webpack_public_path__ + "media/components/dashboard/icons/warn-ico-d3f73d04d77c1167f4b885ac109183b4.svg";